import { takeLatest, call,put } from "redux-saga/effects";
import { 
  SET_PROFILE,
  CHK_ACC_START, 
  FETCH_CAPB_START,
  FETCH_USER_PREFERENCE_START,
  SAVE_USER_PREFERENCE_START
} from "./profileTypes";
import { 
  chkAccFailAct, 
  setProfile,
  chkAccSuccAct, 
  fetchCapbSuccAct, 
  fetchCapbFailAct,
  fetchUserPreferenceSuccessAct,
  fetchUserPreferenceFailAct,
  saveUserPreferenceSuccessAct,
  saveUserPreferenceFailAct
} from "./profileActions";
import {chkAccAPI, getCapbAPI, getUserPreferenceAPI, saveUserPreferenceAPI } from "../../apis/pgapis";
import { showLoader, refreshApp } from "../ctrl/ctrlActions";
import toastr from 'toastr';
import "toastr/build/toastr.min.css";

// Helper function to normalize response columns
function normalizePreferenceColumns(response) {
  const columnMapping = {
    'package': 'column',
    'project': 'column',
    'tagworkspace': 'column'
  };

  const columnKey = columnMapping[response.preference_key];
  if (columnKey && response[columnKey]) {
    response.columns = response[columnKey];
    delete response[columnKey];
  }
  
  return response;
}

export function* onSSOLoginAsync(payload) {
  try {
    yield call(setProfile, payload);
  } catch (e) {}
}

export function* onSSOLogin() {
  yield takeLatest(SET_PROFILE, onSSOLoginAsync);
}

export function* onGetAccAsync(payload) {
  try {
    const response = yield call(chkAccAPI, payload);
    yield put(chkAccSuccAct(response));
    //yield put(showLoader(false));
  } catch (e) {
    if(e?.response?.status === 403){ yield put(refreshApp(true))}
    yield put(chkAccFailAct (e));
  }
}

export function* onGetAcc() {
  yield takeLatest(CHK_ACC_START, onGetAccAsync);
}

export function* getCapbAsync(payload){
  try{
    const response = yield call(getCapbAPI,payload);
    yield put(fetchCapbSuccAct(response));
  } catch(e){
    if(e?.response?.status === 403){ yield put(refreshApp(true))}
    yield put(fetchCapbFailAct(e));
  }
}

export function* getCapb(){
  yield takeLatest(FETCH_CAPB_START,getCapbAsync)
}

// Fetch User Preference Saga
export function* fetchUserPreferenceAsync(action) {
  try {
     yield put(showLoader(true));
    const response = yield call(getUserPreferenceAPI, action.payload);
    const normalizedResponse = normalizePreferenceColumns(response);
    
    yield put(fetchUserPreferenceSuccessAct(normalizedResponse));
    yield put(showLoader(false));
  } catch (e) {   
    if(e?.response?.status === 403){ 
      yield put(refreshApp(true))
    }
    yield put(fetchUserPreferenceFailAct(e));
    yield put(showLoader(false));
  }
}

export function* fetchUserPreference() {
  yield takeLatest(FETCH_USER_PREFERENCE_START, fetchUserPreferenceAsync);
}

// Save User Preference Saga
export function* saveUserPreferenceAsync(action) {
  try {
    yield put(showLoader(true));
    const response = yield call(saveUserPreferenceAPI, action.payload);
    yield put(saveUserPreferenceSuccessAct(response));
    
    const normalizedResponse = normalizePreferenceColumns(response);
    
    yield put(fetchUserPreferenceSuccessAct(normalizedResponse));
    yield put(showLoader(false));
    toastr.success("User preferences saved successfully!");
  } catch (e) {
    if(e?.response?.status === 403){ 
      yield put(refreshApp(true))
    }
    yield put(saveUserPreferenceFailAct(e));
    yield put(showLoader(false));
    toastr.error("Failed to save user preferences!");
  }
}

export function* saveUserPreference() {
  yield takeLatest(SAVE_USER_PREFERENCE_START, saveUserPreferenceAsync);
}